import { DataConnectionError, provideDataClass } from "scrivito"

import { apolloClient } from "app/apolloRestLink"

import {
  ProjectByShareLinkDocument,
  ProjectByShareLinkQuery,
  ProjectByShareLinkQueryVariables
} from "features/project-sharing/graphql/queries.generated"

export const SharedProjectDataClass = provideDataClass("SharedProject", {
  connection: {
    get: async id => {
      return apolloClient
        .query<ProjectByShareLinkQuery, ProjectByShareLinkQueryVariables>({
          query: ProjectByShareLinkDocument,
          variables: { id }
        })
        .then(result => {
          if (!result.data.projectByShareLink) return null

          return {
            ...result.data.projectByShareLink,
            _id: id,
            projectId: result.data?.projectByShareLink?.id,
            shareId: id
          }
        })
        .catch(() => null)
    },

    index: async () => {
      throw new DataConnectionError(
        "Listing all shared projects is not possible."
      )
    }
  },
  attributes: {
    id: "string",
    projectId: "string",
    shareId: "string",
    title: "string"
  }
})
